export type NoticeEffectiveDateHelpVariant =
  | 'CONSENT_NOTICE'
  | 'CONSENT_NOTICE_OTP'
  | 'CONSENT_NOTICE_LINK'
  | 'BREACH_NOTICE'
  | 'ERASURE_NOTICE'
  | 'INFORMATIONAL_NOTICE'
  | 'BULK_MIXED';

export const NOTICE_EFFECTIVE_DATE_HELP: Record<NoticeEffectiveDateHelpVariant, string> = {
  CONSENT_NOTICE:
    'Assigned date is when the message is sent. Effective date is when the notice applies and the data principal can respond in the portal. Example: notify on 15 Jun, applies from 1 Jul.',
  CONSENT_NOTICE_OTP:
    'OTP in SMS is only available for immediate notices (effective date is today). The OTP expires in about 20 minutes.',
  CONSENT_NOTICE_LINK:
    'Uses a link-only SMS template (no OTP). You can notify today while the notice applies from a future date; the portal blocks consent until that date.',
  BREACH_NOTICE:
    'Effective date is when this breach notice applies to the data principal. You can send the message today so they are informed before that date.',
  ERASURE_NOTICE:
    'Effective date is when erasure completes or applies. You may send the notice earlier so the data principal knows what to expect.',
  INFORMATIONAL_NOTICE:
    'Effective date is when updated policy or information applies. Example: send on 25 Mar, new terms apply from 1 Apr.',
  BULK_MIXED:
    'One effective date applies to all selected notices and data principals. Messages are sent when you assign; the portal may block action until the effective date.',
};
